import { useSimulation } from "../simulation/SimulationProvider";
import { PHASE_NAMES } from "../simulation/types";

export function PhaseSelector() {
  const { selectPhase, snapshot } = useSimulation();

  return (
    <fieldset className="control-group phase-selector">
      <legend>Phase positions</legend>
      <ul aria-label="Phase positions" className="phase-grid">
        {PHASE_NAMES.map((phaseName, phaseIndex) => {
          const isSelected = snapshot.phaseIndex === phaseIndex;

          return (
            <li key={phaseName}>
              <button
                type="button"
                aria-current={isSelected ? "true" : undefined}
                onClick={() => selectPhase(phaseIndex, "shortest")}
              >
                {phaseName} position
              </button>
            </li>
          );
        })}
      </ul>
    </fieldset>
  );
}
